import { render, staticRenderFns } from "./ApprovedByMeDetail.vue?vue&type=template&id=495084ab&"
import script from "./ApprovedByMeDetail.vue?vue&type=script&lang=js&"
export * from "./ApprovedByMeDetail.vue?vue&type=script&lang=js&"
import style0 from "./ApprovedByMeDetail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports